import React, { useState, useEffect } from 'react';
import { useCookies } from '../hooks/useCookies';
import { useTranslation } from 'react-i18next';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);
  const [showCustomize, setShowCustomize] = useState(false);
  const { updateCookies } = useCookies();
  console.log(showCustomize);
  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
      // Mark body so floating widgets offset above banner
      document.body.classList.add('cookie-banner-visible');
    }

    // Cleanup to ensure class is removed if component unmounts
    return () => {
      document.body.classList.remove('cookie-banner-visible');
    };
  }, []);

  // Keep body class in sync with banner visibility (extra safety)
  useEffect(() => {
    if (showBanner) {
      document.body.classList.add('cookie-banner-visible');
    } else {
      document.body.classList.remove('cookie-banner-visible');
    }
  }, [showBanner]);

  const handleAcceptAll = () => {
    const allAccepted = {
      necessary: true,
      analytics: true,
      marketing: true,
      preferences: true,
    };
    updateCookies(allAccepted);
    setShowBanner(false);
    setShowCustomize(false);
    document.body.classList.remove('cookie-banner-visible');
  };

  const handleRejectAll = () => {
    const onlyNecessary = {
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false,
    };
    updateCookies(onlyNecessary);
    setShowBanner(false);
    setShowCustomize(false);
    document.body.classList.remove('cookie-banner-visible');
  };

  const handleCustomize = () => {
    setShowCustomize(true);
  };

  const handleClose = () => {
    setShowBanner(false);
    setShowCustomize(false);
    document.body.classList.remove('cookie-banner-visible');
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Desktop */}
      <div className="fixed bottom-0 right-0 z-50 bg-white border-2 border-[#CFD8DC] rounded-lg py-4 px-8 max-w-[1180px] w-full lg:block hidden">
        <div className="flex items-center justify-start flex-wrap gap-4">
          <div
            className="border border-[#E2E8F0] bg-white rounded-full w-12 h-12 hidden lg:flex items-center justify-center relative"
            style={{ boxShadow: '0px 2px 4px 0px #171B1E26' }}
          >
            <svg
              width="28"
              height="29"
              viewBox="0 0 28 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.1071 11.8039C15.5037 11.8039 14.9923 11.5929 14.5726 11.171C14.153 10.7492 13.9432 10.2369 13.9432 9.63416C13.9432 9.03147 14.1544 8.52055 14.5768 8.1014C14.9991 7.68225 15.512 7.47267 16.1153 7.47267C16.7187 7.47267 17.2301 7.68362 17.6497 8.10552C18.0694 8.52739 18.2792 9.03969 18.2792 9.6424C18.2792 10.2451 18.068 10.756 17.6456 11.1752C17.2233 11.5943 16.7104 11.8039 16.1071 11.8039ZM18.9044 18.7897C18.3011 18.7897 17.7896 18.5788 17.37 18.1569C16.9504 17.735 16.7406 17.2227 16.7406 16.62C16.7406 16.0173 16.9518 15.5064 17.3741 15.0872C17.7965 14.6681 18.3093 14.4585 18.9127 14.4585C19.516 14.4585 20.0275 14.6694 20.4471 15.0913C20.8667 15.5132 21.0765 16.0255 21.0765 16.6282C21.0765 17.2309 20.8653 17.7418 20.443 18.161C20.0207 18.5801 19.5078 18.7897 18.9044 18.7897ZM9.81712 20.117C9.42083 20.117 9.08864 19.9831 8.82056 19.7153C8.55248 19.4475 8.41844 19.1157 8.41844 18.7198C8.41844 18.324 8.55248 17.9922 8.82056 17.7244C9.08864 17.4566 9.42083 17.3227 9.81712 17.3227C10.2134 17.3227 10.5456 17.4566 10.8137 17.7244C11.0818 17.9922 11.2158 18.324 11.2158 18.7198C11.2158 19.1157 11.0818 19.4475 10.8137 19.7153C10.5456 19.9831 10.2134 20.117 9.81712 20.117ZM14.005 28.5C15.922 28.5 17.7313 28.1332 19.4331 27.3997C21.1348 26.6662 22.6209 25.6649 23.8914 24.3958C25.1618 23.1267 26.1642 21.6423 26.8985 19.9424C27.6328 18.2425 28 16.4378 28 14.5284C28 12.386 27.5454 10.3834 26.6363 8.52055C25.7271 6.65766 24.5091 5.08003 22.9822 3.78765C21.4553 2.49527 19.6953 1.56383 17.7022 0.993322C15.7091 0.422813 13.6402 0.347134 11.4955 0.766283C11.6354 1.81416 11.5422 2.80381 11.2158 3.73526C10.8894 4.6667 10.3941 5.45843 9.72971 6.11044C9.06533 6.76245 8.26692 7.23981 7.33446 7.54253C6.40201 7.84525 5.42293 7.91511 4.39723 7.75211C4.86346 9.17256 4.60703 10.4475 3.62795 11.5768C2.64888 12.7062 1.46 13.3291 0.0613117 13.4456C-0.125179 15.4714 0.113762 17.3925 0.778137 19.2089C1.44251 21.0252 2.41576 22.6203 3.69789 23.9941C4.98001 25.368 6.50451 26.4625 8.27137 27.2775C10.0382 28.0925 11.9494 28.5 14.005 28.5Z"
                fill="#64748B"
              />
            </svg>
            <svg
              width="16"
              height="16"
              className=" absolute -bottom-[1px] -right-[1px]"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="8.38002" cy="7.61905" r="4.57143" fill="white" />
              <path
                d="M5.76602 15L4.49935 12.8333L1.98268 12.3167L2.26602 9.86667L0.666016 8L2.26602 6.15L1.98268 3.7L4.49935 3.18333L5.76602 1L7.99935 2.03333L10.2327 1L11.516 3.18333L14.016 3.7L13.7327 6.15L15.3327 8L13.7327 9.86667L14.016 12.3167L11.516 12.8333L10.2327 15L7.99935 13.9667L5.76602 15ZM7.28268 10.2167L11.066 6.46667L10.316 5.78333L7.28268 8.78333L5.69935 7.13333L4.93268 7.88333L7.28268 10.2167Z"
                fill="black"
              />
            </svg>
          </div>

          <h3 className="xl:w-[150px] text-[16px] leading-[20px] font-normal roboto tracking-[0.44px] text-black">
            {t('cookie.titleValue') || 'We Value'} <br />{' '}
            <span className="text-[#222222] text-[20px] leading-[24px] font-bold roboto">
              {' '}
              {t('cookie.titlePrivacy') || 'Your Privacy.'}
            </span>
          </h3>
          <p className="text-[14px] leading-[20px] font-normal roboto tracking-[0.25px] text-[#37474F] max-w-[333px] w-full">
            {t('cookie.description')}
          </p>

          <button
            onClick={handleAcceptAll}
            className="bg-black text-white px-4 h-10 rounded-lg text-[14px] roboto uppercase font-medium"
          >
            {t('cookie.acceptAll')}
          </button>
          <button
            onClick={handleCustomize}
            className="bg-white text-[#37474F] border-2 border-[#CFD8DC] px-4 h-10 rounded-lg text-[14px] roboto font-medium flex items-center gap-2.5"
          >
            {t('cookie.customize')}
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 11.8333V13.1667H6V11.8333H2ZM2 3.83333V5.16667H8.66667V3.83333H2ZM8.66667 14.5V13.1667H14V11.8333H8.66667V10.5H7.33333V14.5H8.66667ZM4.66667 6.5V7.83333H2V9.16667H4.66667V10.5H6V6.5H4.66667ZM14 9.16667V7.83333H7.33333V9.16667H14ZM10 6.5H11.3333V5.16667H14V3.83333H11.3333V2.5H10V6.5Z"
                fill="#37474F"
              />
            </svg>
          </button>
          <button
            onClick={handleRejectAll}
            className="h-10 text-[14px] font-medium roboto text-[#37474F] uppercase roboto"
          >
            {t('cookie.rejectAll')}
          </button>
          <button
            onClick={handleClose}
            className=" absolute top-0 right-0 bg-[#CFD8DC] rounded-bl-lg rounded-tr-sm w-[46px] h-[46px] flex items-center justify-center"
          >
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.66 5.99975L6.43359 17.9997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6.43359 5.99975L18.66 17.9997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile */}
      <div className="fixed bottom-0 h-[168px] left-0 z-50 bg-white border-2 border-[#CFD8DC] rounded-lg p-4 max-w-[288px] w-full lg:hidden block">
        <button
          onClick={handleClose}
          className=" absolute -top-3 -right-3 bg-[#CFD8DC] rounded-full w-10 h-10 flex items-center justify-center"
        >
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.66 5.99975L6.43359 17.9997"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.43359 5.99975L18.66 17.9997"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <h3 className="text-[16px] leading-[28px] font-normal roboto tracking-[0.44px] text-black">
          {t('cookie.titleValue') || 'We Value'}{' '}
          <span className="font-bold text-[18px] leading-[28px]">
            {' '}
            {t('cookie.titlePrivacy') || 'Your Privacy.'}
          </span>
        </h3>
        <p className="text-[12px] leading-[16px] font-normal roboto tracking-[0.4px] text-[#37474F] my-2">
          {t('cookie.description')}
        </p>
        <div className="grid grid-cols-2 gap-2">
          <button
            onClick={handleAcceptAll}
            className="bg-black text-white px-4 h-[34px] rounded-lg text-[10px] tracking-[0.4px] roboto uppercase font-normal"
          >
            {t('cookie.acceptAll')}
          </button>
          <button
            onClick={handleCustomize}
            className="bg-white text-[#37474F] border-2 border-[#CFD8DC] px-4 h-[34px] tracking-[.8px] rounded-lg text-[10px] roboto font-medium flex items-center justify-center gap-2.5"
          >
            {t('cookie.customize')}
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 11.8333V13.1667H6V11.8333H2ZM2 3.83333V5.16667H8.66667V3.83333H2ZM8.66667 14.5V13.1667H14V11.8333H8.66667V10.5H7.33333V14.5H8.66667ZM4.66667 6.5V7.83333H2V9.16667H4.66667V10.5H6V6.5H4.66667ZM14 9.16667V7.83333H7.33333V9.16667H14ZM10 6.5H11.3333V5.16667H14V3.83333H11.3333V2.5H10V6.5Z"
                fill="#37474F"
              />
            </svg>
          </button>
        </div>
        <div className="flex items-center justify-center mt-2">
          <button
            onClick={handleRejectAll}
            className="h-[18px] text-[10px] leading-[10px] font-medium tracking-[1.5px] underline roboto text-[#37474F] uppercase roboto"
          >
            {t('cookie.rejectAll')}
          </button>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;
